import { minutesOrHours } from '@/lib/util'
import Model from './Model'
import KintellCard from './KintellCard'
import KintellCredit from './KintellCredit'

export default class User extends Model {
  resource () {
    return 'users'
  }

  kintellCards () {
    return this.hasMany(KintellCard)
  }

  transform (data) {
    if (!data) {
      return data
    }
    if (data.createdAt) {
      data.createdAtUtc = this.$moment.utc(data.createdAt)
    }
    if (data.activeKintellCredits) {
      data.activeKintellCredits = data.activeKintellCredits.map(credit => new KintellCredit(credit))
    }

    return data
  }

  /**
   * Convert a given UTC time to a moment instance which has been converted to the users time zone
   * @param s The UTC time to parse and convert to the timezone we're using
   * @returns moment
   */
  utcToMyTz (s) {
    if (this.$moment.isMoment(s)) {
      return s.clone().tz(this.timezone)
    }
    return this.$moment.utc(s).tz(this.timezone)
  }

  get hasProvidedLearningInterests () {
    return (this.interests && this.interests.length > 0) || (this.categoryInterests && this.categoryInterests.length > 0)
  }

  get proBonoHours () {
    const hours = (this.proBonoMinutes / 60).toFixed(1)
    return hours + ' hour' + (hours !== (1).toFixed(1) ? 's' : '') + ' a month'
  }

  get proBonoHoursShort () {
    const hours = (this.proBonoMinutes / 60).toFixed(1)
    return hours + ' Hr' + (hours !== (1).toFixed(1) ? 's' : '') + '/Mth'
  }

  get fullName () {
    return this.firstName + ' ' + this.lastName
  }

  get isLearner () {
    return this.type === 'Learner'
  }

  get isAbleToSendInvites () {
    return this.type !== 'Learner'
  }

  get languagesSpokenFriendly () {
    if (!this.languagesSpoken) {
      return ''
    }
    return this.languagesSpoken.join(', ')
  }

  calendar () {
    return this.getAction('calendar')
  }

  get advisorProfileLink () {
    return '/advisors/' + this.slug
  }

  // authenticated user only functions
  // @todo make Me model

  get proBonoString () {
    return minutesOrHours(this.stats.proBonoCreditMinutes)
  }

  get credit () {
    return this.stats.creditAvailable / 100
  }

  get hasActiveBooking () {
    return this.stats.bookingRequestsLearning !== 0 ||
      this.stats.bookingRequestsAdvising !== 0 ||
      this.stats.bookingsConfirmed !== 0
  }

  get hasBookings () {
    return this.stats.bookingRequestsLearning !== 0 ||
      this.stats.bookingRequestsAdvising !== 0 ||
      this.stats.bookingsConfirmed !== 0 ||
      this.stats.bookingsArchived !== 0
  }
}
